var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppNavigation",
    [
      _c(
        "router-link",
        { attrs: { to: "/recipe/create" } },
        [
          _c("AppNavigationNew", {
            staticClass: "create",
            attrs: {
              text: _vm.t("cookbook", "Create recipe"),
              "button-id": "cookbook_new_cookbook",
              "button-class": ["create", "icon-add"],
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "list" },
        [
          _c(
            "ActionInput",
            {
              staticClass: "download",
              attrs: {
                disabled: _vm.downloading ? "disabled" : null,
                icon: _vm.downloading ? "icon-loading-small" : "icon-download",
              },
              on: { submit: _vm.downloadRecipe },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.t("cookbook", "Download recipe from URL")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "AppNavigationItem",
            {
              attrs: {
                title: _vm.t("cookbook", "All recipes"),
                icon: "icon-category-organization",
                to: "/",
              },
            },
            [
              _c(
                "AppNavigationCounter",
                { attrs: { slot: "counter" }, slot: "counter" },
                [_vm._v(_vm._s(_vm.totalRecipeCount))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "AppNavigationItem",
            {
              attrs: {
                title: _vm.t("cookbook", "Uncategorized recipes"),
                icon: "icon-category-organization",
                to: "/category/_/",
              },
            },
            [
              _c(
                "AppNavigationCounter",
                { attrs: { slot: "counter" }, slot: "counter" },
                [_vm._v(_vm._s(_vm.uncatRecipes))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading.categories || _vm.categories.length > 0
            ? _c(
                "AppNavigationCaption",
                {
                  attrs: {
                    title: _vm.t("cookbook", "Categories"),
                    loading: _vm.loading.categories,
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "actions" },
                    [
                      _c(
                        "ActionButton",
                        {
                          attrs: { icon: "icon-rename" },
                          on: { click: _vm.toggleCategoryRenaming },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.t("cookbook", "Toggle editing")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.categories, function (cat, idx) {
            return _c(
              "AppNavigationItem",
              {
                key: cat + idx,
                ref: "app-navi-cat-" + idx,
                refInFor: true,
                attrs: {
                  title: cat.name,
                  icon: _vm.categoryUpdating[idx] ? "" : "icon-category-files",
                  loading: _vm.categoryUpdating[idx],
                  "allow-collapse": true,
                  to: "/category/" + cat.name,
                  editable: _vm.catRenamingEnabled,
                  "edit-label": _vm.t("cookbook", "Rename"),
                  "edit-placeholder": _vm.t(
                    "cookbook",
                    "Enter new category name"
                  ),
                },
                on: {
                  "update:open": function ($event) {
                    return _vm.categoryOpen(idx)
                  },
                  "update:title": function (val) {
                    _vm.categoryUpdateName(idx, val)
                  },
                },
              },
              [
                !_vm.catRenamingEnabled
                  ? _c(
                      "AppNavigationCounter",
                      { attrs: { slot: "counter" }, slot: "counter" },
                      [_vm._v(_vm._s(cat.recipeCount))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(cat.recipes, function (rec, idy) {
                  return _c("AppNavigationItem", {
                    key: idx + "-" + idy,
                    staticClass: "recipe",
                    attrs: {
                      title: rec.name,
                      to: "/recipe/" + rec.recipe_id,
                      icon:
                        _vm.$store.state.loadingRecipe ===
                          parseInt(rec.recipe_id) || !rec.recipe_id
                          ? "icon-loading-small"
                          : "icon-file",
                    },
                  })
                }),
              ],
              2
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("AppSettings", {
            attrs: { "scanning-library": _vm.scanningLibrary },
            on: { reindex: _vm.reindex },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }